﻿// NOTE: Update the ?v= number in the service worker after changes to this file.

// Create/open the leanforms database.
var indexedDatabase = new Dexie("LeanForms");

// Create stores/tables.
// Fields in strings are indexed, fields in comment are also stored.
indexedDatabase.version(5).stores({
    // lastChange, lists, html, title, toolbar, init, matrices.
    formTypes: "baseId, id",
    formTypeUsers: "++id, formTypeBaseId, userId, [userId+formTypeBaseId]",

    // type, data, questionId.
    attachments: "++id",

    // action, formTypeId, baseId, data, attachments, matrixAttachments, createdAt, title.
    forms: "++id, userId",

    // Delete webforms table, renamed to forms.
    webforms: null,

    // guid, code, syncedAt, action.
    syncedForms: "id, userId",

    // value.
    organizationUnits: "key"
}).upgrade(transaction => {
    // Rename webforms table to forms.
    return transaction.webforms?.toArray().then(forms => {
        return transaction.forms.bulkAdd(forms);
    });
});
